import { EntityRepository, Repository } from "typeorm";
import { RmAntiBioticsTest } from "./rm-antibiotics-report.entity";
@EntityRepository(RmAntiBioticsTest)
export class RmAntiBioticsRepository extends Repository<RmAntiBioticsTest> {

}